import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Hair forms
   */
  {
    label: 'As BMI is not a perfect measure, to ensure that the medication will be safe and effective for your unique body composition, please upload two head-to-toe, full body images (one front-view, one side-view). Please wear form fitting clothes.',
    field: 'wLPhotos',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'frontBody',
        label: 'Front-view full body image',
        buttonLabel: 'Choose File',
        defaultImage: 'frontBodyView.png'

      },
      {
        resourceId: 'sideBody',
        label: 'Side-view full body image',
        buttonLabel: 'Choose File',
        defaultImage: 'sideBodyView.png'
      }
    ]
  }
];

export default questionsModels;